import React, { useEffect,useState } from "react";
// import { actions } from "../../actions";
// import { useSelector, useDispatch } from "react-redux";
import { Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";

import "./dashboard.scss";
import ActiveSummary from "../ActiveSummaryBlock";
import useStatsStore from "../../store/stats.store";  
import useMembersStore from "../../store/members.store";
import InterviewCountCard from "../interviewCountCard";


function Dashboard() {

    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const { getClients,checkSubscriptions,currSubscription, getTeamMembers,
            clients ,clientsFlag,resetClientsFlag
     } = useMembersStore();
    const { getGraphsGroupUserStats} = useStatsStore();
    const {getMyDashBoardConsolidatedStatsResumesShared,getTeamsDashBoardConsolidatedStatsResumesShared} = useStatsStore();
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isVendorSupported, setVendorSupported] = useState(false);
    const navigate = useNavigate();

    const showModal = () => {
        setIsModalOpen(true);
      };
      const handleOk = () => {
        if(userDetails.permission == "superadmin"){
            navigate('/superadmin')
            setIsModalOpen(false)
        }
        else
            navigate('/usersubscription')
      };
      const handleCancel = () => {
        if(userDetails.permission == "superuser")
            navigate(`/superuser`)
        else if(userDetails.permission == "superadmin")
            navigate('/superadmin')
        else
            navigate('/usersubscription')
      }; 

      const displaySubscriptionStatus =(status)=>{
        if(status === "trial_none"){return "-"}
        if(status === "trial_inactive"){return "VERIFICATION PENDING"}
        if(status === "trial_active"){return "ACTIVE"}
        if(status === "trial_expired"){return "EXPIRED"}   
        if(status === "trial_stop"){return "STOP"}
        if(status === "trial_activation_in_progress"){return "ACTIVATION IN PROGRESS"}
        if(status === "trial_expired"){return "EXPIRED"}     
        if(status === "subscription_none"){return "-"}
        if(status === "subscription_inactive"){return "INACTIVE"}
        if(status === "subscription_new_req"){return "NEW REQ "}
        if(status === "subscription_configured"){return "CONFIGURED"}
        if(status === "subscription_active"){return "ACTIVE"}
        if(status === "subscription_expired"){return "EXPIRED"}
        if(status === "subscription_stopped"){return "STOPPED"} 
        if(status === "subscription_aborted"){return "ABORTED"} 
        if(status === "subscription_activation_in_progress"){return "ACTIVATION IN PROGRESS"}
    } 
      const getCurrentSubscription = () => {
           return displaySubscriptionStatus(currSubscription)
      };   
      
    useEffect(() => {
        checkSubscriptions();
     }, []);

    useEffect(() => {
     if(clientsFlag)
        resetClientsFlag()
    }, [clientsFlag]);

    useEffect(() => {    
        //console.log("curret subscription", currSubscription)
        if (currSubscription == null) return;  // skip if null

        if((currSubscription == "trial_active")||(  currSubscription == "subscription_active")){
                //disable the model
                setIsModalOpen(false)
                getClients();
                getTeamMembers();
                let encodedJsonValues ={};
                encodedJsonValues.prio = "All";
                encodedJsonValues.jobstatus = "Active";
                encodedJsonValues.client = "All";
                encodedJsonValues.ta = "All";
                encodedJsonValues.appnum = "All";
                encodedJsonValues.pagenum = 1;
                encodedJsonValues.pagesize = 10;                

                //getTeamsDashBoardConsolidatedStats("24",{...encodedJsonValues});
                //getTeamsInternalConsolidatedStats("24",{...encodedJsonValues});
                //getMyDashBoardConsolidatedStats("24",{...encodedJsonValues});
                //getMyInternalConsolidatedStats("24",{...encodedJsonValues});
                //getJdsConsolidatedStats({...encodedJsonValues});
                getTeamsDashBoardConsolidatedStatsResumesShared("24",encodedJsonValues)
                getMyDashBoardConsolidatedStatsResumesShared("24",encodedJsonValues)
      
                let encodedJsonValues1 ={};
                encodedJsonValues1.group = "All";
                getGraphsGroupUserStats("24",{...encodedJsonValues1});
        }else if ((isModalOpen == false)&&((userDetails.permission != "superuser"))) {
              setIsModalOpen(true)
        }else {
            setIsModalOpen(false)
        }
     }, [currSubscription !=null]);



    return (
        <div className="dashboard-wrapper">
            <InterviewCountCard/>
            <div className="activity-container">
                <ActiveSummary
                    inputData={null}
                    buttonName="See Job"
                    title="Users"
                />
            </div>
            {
                isVendorSupported?
                <>
                    <div className="activity-container">
                    <ActiveSummary
                        inputData={null}
                        buttonName="See Interviews"
                        title="Vendors"
                    />
            </div>  
                </>
                :<>
                </>
            }          
            <Modal title= {"Subscription Status" } open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                    <div style={{ marginTop: "20px" }}>
                        {getCurrentSubscription()}
                    </div>
                    <div style={{ margin: "10px" }}>
                            <p>Kindly Renew, Activate or Get New subscription</p>
                    </div>                    
            </Modal>

        </div>
    );
}

export default Dashboard;
